<template>
  <div class="box-body" style="background: #f4f3ef">
    <div class="">
      <div class="panel-group" id="accordion">
        <div
          class="panel panel-default"
          v-for="(item, index) in departmentList"
          :key="item + index"
        >
          <div
            class="panel-heading cursor-pointer header-hover-class"
            data-toggle="collapse"
            data-parent="#accordion"
            :href="`#collapse${index}`"
            @click="onSelectDepartment(item)"
          >
            <div class="panel-title">
              <span class="department-class btn btn-link">
                <span>{{ $t("feedback.config.departmentName") }}: </span>
                <span style="font-weight: bold"> {{ item.departmentName }}</span>
              </span>
            </div>
          </div>
          <div
            :id="`collapse${index}`"
            :class="
              index === 0
                ? 'panel-collapse collapse in'
                : 'panel-collapse collapse'
            "
          >
            <div class="panel-body">
              <div>
                <lte-button
                  style="float:right"
                  type="btn btn-primary"
                  v-if="GET_ACCOUNT_DATA.group_id == 1 || has_perm('create_case')"
                  right_icon="fa fa-plus"
                  @click="addNew($event)"
                  >{{ $t("invoice.addnew") }}</lte-button
                >
              </div>
              <div>
                <b-table outlined :items="subjectItems" :fields="subjectFields">
                  <template #head()="scope">
                    <div class="">{{ $t(scope.label) }}</div>
                  </template>
                  <template #cell(actions)="row">
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-danger dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="true"
                      >
                        <i class="fa fa-fw fa-ellipsis-h"></i>
                      </button>
                      <ul class="dropdown-menu" style="min-width: 50px;">
                        <li>
                          <button
                            v-if="GET_ACCOUNT_DATA.group_id == 1 || has_perm('update_case')"
                            class="btn btn-primary btn-sm"
                            style="margin-left: 6px;"
                            @click="onShowDetail(row.item)"
                          >
                            <i class="glyphicon glyphicon-edit"></i>
                          </button>
                        </li>
                        <li>
                          <button
                            v-if="GET_ACCOUNT_DATA.group_id == 1 || has_perm('delete_case')"
                            class="btn btn-danger btn-sm"
                            style="margin-left: 6px; margin-top: 6px"
                            @click="onDeleteDepartment(row.item)"
                          >
                            <i class="glyphicon glyphicon-trash"></i>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer clearfix" style="display:contents;">
        <custom-paginator
          :totalItem="departmentPaginateData.totalItem"
          :currentPage="departmentPaginateData.currentPage"
          :pageSize="departmentPaginateData.pageSize"
          :totalPage="departmentPaginateData.totalPage"
          @onpaginate="onCustomPagination"
        />
      </div>
    </div>
    <!-- Modal modal-subject-list -->
    <div class="modal fade" :ref="`modal-subject-list`">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("invoice.template_print") }}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="">{{ $t("feedback.config.subject") }}</label>
              <input
                type="text"
                class="form-control"
                v-model="subjectData.subject"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button type="button" class="btn btn-primary" @click="onSave">
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CustomPaginator from "@/components/CustomPaginator.vue";
import LTEButton from "@/components/LTEButton.vue";
import utils from "@/lib/utils";
export default {
  components: {
    "lte-button": LTEButton,
    CustomPaginator
  },
  data: () => ({
    subjectFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      // {
      //   key: "departmentName",
      //   label: "feedback.config.departmentName"
      // },
      {
        key: "subject",
        label: "feedback.config.subject"
      },
      { key: "actions", label: "common.action" }
    ],
    subjectItems: [],
    departmentList: [],
    departmentPaginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    subjectData: {
      id: 0,
      subject: null,
      departmentId: null
    }
  }),
  watch: {
    GET_DEPARTMENT_LIST_DATA: function() {
      let data = this.GET_DEPARTMENT_LIST_DATA.results;
      let paginate = this.GET_DEPARTMENT_LIST_DATA.paginate;
      this.departmentPaginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.departmentList = [];
      data.forEach((value, i) => {
        let nonumber =
          i +
          1 +
          (this.departmentPaginateData.currentPage - 1) *
            this.departmentPaginateData.pageSize;
        let item = {
          id: value.id,
          nonumber: nonumber,
          departmentName: value.name
        };
        this.departmentList.push(item);
      });
      if (this.departmentList.length > 0) {
        this.subjectData.departmentId = this.departmentList[0].id;
        this.getFeedbackSubjectList();
        // show first collapse when call api
        $(".panel-collapse.in").collapse("hide");
        $("#collapse0").collapse("show");
      }
    },
    GET_FEEDBACK_SUBJECT_LIST_DATA: function() {
      let data =
        this.GET_FEEDBACK_SUBJECT_LIST_DATA.results != undefined
          ? this.GET_FEEDBACK_SUBJECT_LIST_DATA.results
          : this.GET_FEEDBACK_SUBJECT_LIST_DATA;
      this.subjectItems = [];
      data.forEach((value, index) => {
        let item = {
          id: value.id,
          nonumber: index + 1,
          subject: value.subject
        };
        this.subjectItems.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_DEPARTMENT_LIST_DATA",
      "GET_FEEDBACK_SUBJECT_LIST_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    addNew: function(event) {
      event.preventDefault();
      $(this.$refs[`modal-subject-list`]).modal("show");
      this.subjectData.id = 0;
      this.subjectData.subject = null;
    },
    onShowDetail: function(data) {
      $(this.$refs[`modal-subject-list`]).modal("show");
      this.subjectData.id = data.id;
      this.subjectData.subject = data.subject;
    },
    onDeleteDepartment: function() {},
    getDepartmentList: function(page) {
      let filter = {
        params: {
          page: page
        }
      };
      this.GET_DEPARTMENT_LIST(filter);
    },
    onRefreshData: function() {
      this.getDepartmentList(1);
    },
    onSave: function() {
      if (utils.isEmptyString(this.subjectData.subject)) {
        this.ON_SHOW_TOAST({
          message: this.$t("feedback.config.subject"),
          styleType: "danger"
        });
      } else {
        let data = {
          id: this.subjectData.id,
          subject: this.subjectData.subject,
          departmentId: this.subjectData.departmentId
        };
        if (this.subjectData.id === 0) {
          this.CREATE_FEEDBACK_SUBJECT(data)
            .then(
              function() {
                $(this.$refs[`modal-subject-list`]).modal("hide");
                this.getFeedbackSubjectList();
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false;
                this.ON_SHOW_TOAST();
              }.bind(this)
            );
        } else {
          this.UPDATE_FEEDBACK_SUBJECT(data)
            .then(
              function() {
                $(this.$refs[`modal-subject-list`]).modal("hide");
                this.getFeedbackSubjectList();
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                this.isLoading = false;
                this.ON_SHOW_TOAST();
              }.bind(this)
            );
        }
      }
    },
    getFeedbackSubjectList: function() {
      let filter = {
        params: {
          departmentId: this.subjectData.departmentId
        }
      };
      this.GET_FEEDBACK_SUBJECT_LIST(filter);
    },
    onCustomPagination: function(data) {
      this.departmentPaginateData.currentPage = data;
      this.getDepartmentList(data);
    },
    onSelectDepartment: function(item) {
      this.subjectData.departmentId = item.id;
      this.getFeedbackSubjectList();
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "GET_DEPARTMENT_LIST",
      "GET_FEEDBACK_SUBJECT_LIST",
      "CREATE_FEEDBACK_SUBJECT",
      "UPDATE_FEEDBACK_SUBJECT"
    ])
  }
};
</script>
<style scoped>
.card {
  border-radius: 6px;
  box-shadow: 0 2px 2px rgb(204 197 185 / 50%);
  background-color: #fff;
  color: #252422;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  border: none;
}
.header-hover-class:hover {
  background: #03d7fc;
}
.btn {
  touch-action: none;
}
/* .btn:hover {
  color: white;
} */
.department-class {
  border-color: transparent !important;
  padding: 7px 18px;
  width: 100%;
  text-align: left;
}
.cursor-pointer {
  cursor: pointer;
}
.panel-default > .panel-heading {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Case/SubjectList.vue